import { render } from "./DetailSerie.vue?vue&type=template&id=74e4654d&scoped=true"
import script from "./DetailSerie.vue?vue&type=script&lang=js"
export * from "./DetailSerie.vue?vue&type=script&lang=js"

import "./DetailSerie.vue?vue&type=style&index=0&id=74e4654d&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e4654d"]])

export default __exports__